export default __webpack_public_path__ + "static/media/collab.4448cb61.png";